/** 
 * TABS
 */
import { map } from "lodash"
import { useState } from "react"
import { connect } from "react-redux"
import { Session } from "@/redux/_session.types"

interface StateProps {
  _session : Session
}

interface OwnProps{
  active : string
  onClick : Function
  tabs : any
  onReorder? : (tabIds : string[]) => void //If defined, the tabs can be reordered by drag and drop
}

type Props = StateProps & OwnProps

function Tabs(props:Props) {

  //Tab dragged (drag and drop to reorder)
  const [draggedId, setDraggedId] = useState<string | null>(null)

  //Get class
  //Depends of the active tab
  function getClassName(tabId){
    let className = "selector-tabs-tab flex"

    if (tabId === props.active){
      className = className + " selector-tabs-tab-active"
    }else{
      className = className + " grey-t"
    }
    
    return className

  }

  //Click on tab
  function clickTab(tab){
    props.onClick(tab)
  }

  //Drop a tab on another one : place it at its position
  function dropTab(tabId){
    if (!props.onReorder || !draggedId || draggedId === tabId) return
    const allIds = getTabs().map(x => x.id)
    const ids = allIds.filter(id => id !== draggedId)
    ids.splice(allIds.indexOf(tabId), 0, draggedId)
    props.onReorder(ids)
  }

  //Build tab array from the object in props
  function getTabs(){
    return map(props.tabs, (label, id) => ({ label, id }))
  }

  return (
    <div className="flex selector-tabs">

      { getTabs().map(tab =>
      <div className={getClassName(tab.id)}
        key={tab.id}
        draggable={!!props.onReorder}
        onDragStart={() => setDraggedId(tab.id)}
        onDragOver={(e) => props.onReorder && e.preventDefault()}
        onDrop={() => dropTab(tab.id)}
        onDragEnd={() => setDraggedId(null)}
        onClick={() => clickTab(tab.id)}>

        <div style={{ margin : 'auto' }}>
          { tab.label }
        </div>

        { tab.id === props.active &&
        <div style={{ 
            backgroundColor : props._session.accountColors.active 
          }} 
          className="selector-tabs-tab-active-bottom">
        </div>
        }

      </div>
      )
      }
      
    </div>
  )

}


const mapStateToProps = state => ({
  _session : state._session
})

export default connect(mapStateToProps)(Tabs)